import { TrainingCalc, TrainingCalcProps } from '../@types/Calculations';

function asPercent(value: number) {
  return value / 100;
}

export const calcTrainingTick = ({
  acres,
  training,
  razeCost,
  constructionCost,
  thiefCost,
  existingMoney,
  armyCalc,
  dSpecCost,
  oSpecCost,
  eliteCost,
  recruitsNeeded,
}: TrainingCalcProps) => {
  const acresToRaze = Math.floor(acres * asPercent(training.razePcnt));
  const razingCost = acresToRaze * razeCost;
  const buildingCosts =
    Math.max(acresToRaze - training.buildCredits, 0) * constructionCost;
  const conversionCost = Math.floor(razingCost + buildingCosts);
  const targetThieves = Math.floor(acres * training.rawTpa);
  const thievesToTrain = targetThieves - armyCalc.thieves;
  const dragonMoney = Math.floor(acres * training.gcpa);
  const totalTrainingMoney = existingMoney - conversionCost - dragonMoney;
  const thievesTrainingCost = thievesToTrain * thiefCost;
  const dSpecToTrain = acres * training.dspa - armyCalc.dSpecs;
  const creditsUsedForDSpecs = Math.min(dSpecToTrain, training.trainCredits);
  const dSpecsTrainingCost = Math.max(
    0,
    (dSpecToTrain - creditsUsedForDSpecs) * dSpecCost
  );
  const creditsForOSpecs = training.trainCredits - creditsUsedForDSpecs;
  const offenseGcs =
    totalTrainingMoney - thievesTrainingCost - dSpecsTrainingCost;
  const soldiersLeftForOffense =
    armyCalc.soldiers +
    Math.max(recruitsNeeded, 0) -
    dSpecToTrain -
    thievesToTrain;
  const maxSoldiersLeftForElites = soldiersLeftForOffense - creditsForOSpecs;

  const maxElitesToTrain = Math.max(
    Math.min(
      Math.floor(
        (maxSoldiersLeftForElites * oSpecCost - offenseGcs) /
          (oSpecCost - eliteCost)
      ),
      maxSoldiersLeftForElites
    ),
    0
  );
  const oSpecsToTrain =
    maxSoldiersLeftForElites - maxElitesToTrain + creditsForOSpecs;
  const elitesTrainingCost = maxElitesToTrain * eliteCost;
  const oSpecsTrainingCost = Math.max(
    0,
    (oSpecsToTrain - creditsForOSpecs) * oSpecCost
  );
  const totalTrainingCost =
    oSpecsTrainingCost +
    dSpecsTrainingCost +
    elitesTrainingCost +
    thievesTrainingCost;
  const trainingMoneyAfterThieves = totalTrainingMoney - thievesTrainingCost;
  const moneyAfterConversionAndTraining =
    existingMoney - conversionCost - totalTrainingCost;
  const totalArmySizeAfterTrain =
    armyCalc.total +
    oSpecsToTrain +
    maxElitesToTrain +
    dSpecToTrain +
    thievesToTrain;

  const result: TrainingCalc = {
    totalArmySizeAfterTrain,
    moneyAfterConversionAndTraining,
    trainingMoneyAfterThieves,
    dSpecsTrainingCost,
    oSpecsTrainingCost,
    conversionCost,
    dragonMoney,
    totalTrainingMoney,
    thievesTrainingCost,
    targetThieves,
    thievesToTrain,
    dSpecToTrain,
    offenseGcs,
    elitesTrainingCost,
    oSpecsToTrain,
    maxElitesToTrain,
    creditsForOSpecs,
    soldiersLeftForOffense,
    totalTrainingCost,
    trainCredits: training.trainCredits,
  };
  return result;
};
